export * from './auth';
export * from './api';

export const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const isDateStringValid = (date: string): boolean => {
  const dateRegex = /^\d{4}\/\d{2}\/\d{2}$/;
  if (!dateRegex.test(date)) return false;

  const [year, month, day] = date.split('/').map(Number);
  const d = new Date(year, month - 1, day);
  return (
    d.getFullYear() === year &&
    d.getMonth() === month - 1 &&
    d.getDate() === day
  );
};

export const convertDateFormat = (dateStr: string): string => {
  return dateStr.replace(/\//g, '-');
};

export const isNumberValid = (number: string): boolean => {
  const cleaned = number.replace(/[^A-Za-z0-9]/g, '');
  return /^[A-Za-z]{2}[0-9]{8}$/.test(cleaned);
};
